<template>
  <div v-if="module.accessible" class="module" @click.stop="navigateToModule">
    <v-icon color="primary">
      {{ module.icon }}
    </v-icon>

    <!-- Vuetify 2 tooltip -->
    <v-tooltip v-if="shouldShowTooltip" bottom>
      <template #activator="{ on, attrs }">
        <div v-bind="attrs" ref="nameEl" class="module-name" v-on="on">
          {{ truncatedName }}
        </div>
      </template>
      <span>{{ module.name }}</span>
    </v-tooltip>

    <!-- Fallback: if no tooltip needed -->
    <div v-else ref="nameEl" class="module-name">
      {{ truncatedName }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'ModuleTile',
  props: {
    module: { type: Object, required: true },
    project: { type: Object, required: true },
    tooltipThreshold: { type: Number, default: 16 },
  },
  data() {
    return {
      isOverflowing: false,
    };
  },
  computed: {
    shouldShowTooltip() {
      const longByChars =
        (this.module?.name || '').length > this.tooltipThreshold;
      return longByChars || this.isOverflowing;
    },
    truncatedName() {
      const name = this.module?.name || '';
      return name.length > 30 ? name.slice(0, 27) + '…' : name;
    },
  },
  mounted() {
    this.checkOverflow();
    window.addEventListener('resize', this.checkOverflow, { passive: true });
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkOverflow);
  },
  methods: {
    navigateToModule() {
      if (this.module.accessible) this.$emit('moduleClicked');
    },
    checkOverflow() {
      const el = this.$refs.nameEl;
      if (!el) return;
      this.isOverflowing = el.scrollWidth > el.clientWidth;
    },
  },
};
</script>

<style lang="scss" scoped>
.module {
  height: 70px;
  width: 100%;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition:
    transform 160ms ease,
    background 160ms ease;

  &:hover {
    background: #f2f2f2;
    transform: translateY(-1px);
  }

  .module-name {
    margin-top: 4px;
    font-size: 12px;
    line-height: 1.2;
    max-width: 100%;
    padding: 0 6px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: rgba(0, 0, 0, 0.75);
    text-align: center;
  }
}
</style>
